import API from '@/axios/api';

const state = {
    hasAccess: true,
    authHeader: localStorage.getItem('authHeader') || '',
    user: {},
};

const getters = {
    isAuthenticated: state => !!state.authHeader,
    hasAccess: state => state.hasAccess,
    user: state => state.user,
};

const actions = {
    /*eslint-disable no-unused-vars*/
    'login': async ({commit, dispatch}, user) => {
        let credentials = {
            login: user.email,
            password: user.password
        }

        try{
            let response = await API.post('users/login', credentials)

            commit('setAuthHeader', `Bearer ${response.data.user.token}`);
            commit('setUser', response.data.user);
            commit('setServerBinNoticePending', true);

        } catch (e) {
            console.log(e);
        }
    },
    'getUser': ({commit, dispatch}) => {
        return API.post('users/login')
            .then((response) => {
                console.log(response.data);
                commit('setUser', response.data.user);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    'resetHeader': ({commit, dispatch}, user) => {
        if (getters.isAuthenticated) {
            API.defaults.headers.common['Authorization'] = state.authHeader;
            dispatch('getUser');
        }
    },
    'logout': ({commit}) => {
        return new Promise(resolve => {
            commit('removeAuthHeader');
            commit('setActions', []);
            resolve();
        });
    },
};

const mutations = {
    setAuthHeader(state, header) {
        state.authHeader = header;
        API.defaults.headers.common['Authorization'] = state.authHeader;
        localStorage.setItem('authHeader', header)
    },
    removeAuthHeader(state) {
        state.authHeader = '';
        delete API.defaults.headers.common['Authorization'];
        localStorage.removeItem('authHeader')
    },
    setUser(state, user) {
        state.user = user;
    },
    setAccessAvailability(state, access) {
        state.hasAccess = access;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
